module.exports = __webpack_public_path__ + "static/media/img_mj_three.ce41ebc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/img_mj_three.png
// module id = 601
// module chunks = 0